<template>
    <div class="d-flex justify-space-between align-center">
        <v-text-field
            v-model="demand.workedHours"
            :label="$t('demand.form.workedHours.time.label')"
            prepend-icon="av_timer"
            type="number"
            dense
            filled
            readonly
        >
            <template v-slot:append-outer>
                <v-dialog v-model="form.dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on"
                            :loading="loading"
                            :disabled="loading"
                            :dark="!loading"
                            class="ml-1"
                        >{{ $t('common.add') }}</v-btn>
                    </template>
                    <v-form
                        ref="formWorkedHour"
                        v-model="form.valid"
                        lazy-validation
                    >
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ $t('demand.form.workedHours.data') }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="7">
                                        <input-date-picker :setup.sync="form.datePickers.registerDate"></input-date-picker>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-text-field
                                            v-model="workedHour.time"
                                            :label="$t('demand.form.workedHours.time.label')"
                                            :rules="form.rules.time"
                                            prepend-icon="av_timer"
                                            type="number"
                                            min="1"
                                            max="100"
                                            dense
                                            filled
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="error" text @click="clearForm()">{{ $t('common.cancel') }}</v-btn>
                                <v-btn color="primary" @click.native="addWorkedHour()">{{ $t('common.save') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </template>
        </v-text-field>
    </div>
</template>

<script>
import API from '@/api'
import InputDatePicker from '@/components/InputDatePicker'

export default {
    name: 'demand-worked-hour',
    props: ['setup', 'demand'],
    components: {
        InputDatePicker
    },
    data () {
        return {
            loading: false,
            form: {
                dialog: false,
                valid: false,
                showAlert: true,
                labels: {
                    time: this.$t('demand.form.workedHours.time.label')
                },
                rules: {
                    time: [
                        v => !!v || this.$t('demand.form.workedHours.time.rule')
                    ]
                },
                datePickers: {
                    registerDate: {
                        label: this.$t('demand.form.workedHours.registerDate.label'),
                        rule: [
                            v => !!v || this.$t('demand.form.workedHours.registerDate.rule')
                        ],
                        required: true,
                        readonly: false,
                        filled: true,
                        dateFormatted: undefined
                    }
                }
            },
            workedHour: {
                demand: undefined,
                client: undefined,
                user: undefined,
                registerDate: '',
                time: undefined
            }
        }
    },
    methods: {
        clearForm () {
            this.form.dialog = false
            this.$refs.formWorkedHour.reset()
            this.form.valid = false
            this.form.loading = false
        },
        addWorkedHour () {
            if (!this.$refs.formWorkedHour.validate()) {
                return
            }

            const currentUserCompany = JSON.parse(localStorage.currentUserCompany)

            let params = {
                demand: { __type: 'Pointer', className: 'Demand', objectId: this.demand.objectId },
                demandName: this.demand.demand.toLowerCase(),
                client: { __type: 'Pointer', className: 'Client', objectId: this.demand.client.objectId },
                clientName: this.demand.client.name.toLowerCase(),
                registeredAt: { __type: 'Date', iso: new Date(this.form.datePickers.registerDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() },
                responsible: { __type: 'Pointer', className: 'UserCompany', objectId: currentUserCompany.objectId },
                responsibleName: currentUserCompany.nameLowerCase,
                workedHour: parseFloat(this.workedHour.time)
            }

            let endpoint = API.EndPoints.saveDemandWorkedHour
            new API(endpoint, params).request().then(response => {
                this.demand.workedHours += parseFloat(this.workedHour.time)
                window.getApp.refreshWorkedHour = true
                this.$emit('event-interaction')
                this.clearForm()
            }, (e) => {
                this.$helpers.requestError(e)
                this.clearForm()
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
